/*
 * Announcement bar dismissal (HIC-1075).
 *
 * Content-keyed: the stored value is a hash of the current announcement text
 * (emitted on the element as data-hash). The no-flash inline script in
 * announcement-bar.liquid handles hiding on load; this element only handles the
 * click. data-hide is a comma-separated list of selectors to hide — either the
 * whole bar (announcement-only) or the announcement region + this button.
 */
if (!customElements.get('announcement-bar-dismiss')) {
  customElements.define(
    'announcement-bar-dismiss',
    class AnnouncementBarDismiss extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', () => this.dismiss());
      }

      dismiss() {
        (this.dataset.hide || '').split(',').forEach((selector) => {
          const el = document.querySelector(selector.trim());
          if (el) el.style.display = 'none';
        });
        try {
          localStorage.setItem(this.dataset.key, this.dataset.hash);
        } catch (e) {
          // localStorage unavailable (private mode / disabled) — dismissal just won't persist.
        }
      }
    }
  );
}
